// Section16.jsx - Simple Safe Version
import React from 'react';
const icon_1 = "../assets/Healthcare Services Icon.png";
const icon_2 = "../assets/Ecommerce Services Icon.png";
const icon_3 = "../assets/FinTech Services Icon.png";
const icon_4 = "../assets/Education Services Icon.png";
const icon_5 = "../assets/Logistics Services Icon.png";
const icon_6 = "../assets/Real Estate Services Icon.png";


const Section16 = () => {
const industries = [
  {
    name: "Healthcare",
    icon: icon_1,
    items: [
      "Patient engagement apps",
      "Appointment management",
      "Telehealth solutions",
      "Healthcare workflows"
    ]
  },
  {
    name: "Ecommerce",
    icon: icon_2,
    items: [
      "Shopping applications",
      "Loyalty programs",
      "Mobile commerce platforms",
      "Customer engagement tools"
    ]
  },
  {
    name: "FinTech",
    icon: icon_3,
    items: [
      "Payment solutions",
      "Digital wallets",
      "Financial management applications",
      "Secure transaction platforms"
    ]
  },
  {
    name: "Education",
    icon: icon_4,
    items: [
      "E-learning applications",
      "Student portals",
      "Virtual classrooms",
      "Learning management tools"
    ]
  },
  {
    name: "Logistics",
    icon: icon_5,
    items: [
      "Fleet management solutions",
      "Tracking systems",
      "Route optimization tools",
      "Delivery applications"
    ]
  },
  {
    name: "Real Estate",
    icon: icon_6,
    items: [
      "Property listing applications",
      "Agent management platforms",
      "Virtual property experiences",
      "Lead generation tools"
    ]
  }
];

  return (
    <section id="industries" className="bg-gradient-to-b from-[#fafafa] to-white py-10 md:py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[#cd2122] text-xs font-semibold uppercase tracking-widest">Industries</span>
          <h2 className="text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] mt-3">
            Industries We Serve
          </h2>
          <p className="text-[#535353] text-[16px] max-w-xl mt-5 mx-auto">
            Our mobile application development service supports organizations across multiple industries.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, i) => (
            <div
              key={i}
              className="group bg-white rounded-3xl p-8 border border-gray-100 hover:border-[#cd2122] hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="text-5xl mb-6 transition-transform group-hover:scale-110 text-center md:text-left">
                <img src={industry.icon} alt="" width={70} />
                </div>
              <h3 className="text-xl font-bold text-[#1a1a1a] mb-5 text-center md:text-left">{industry.name}</h3>
              <ul className="space-y-2.5 text-[16px] text-[#535353]">
                {industry.items.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-2 justify-center md:justify-start">
                    <span className="text-[#cd2122] ">•</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section16;